import API from "./api";
import { URL } from "./URL";

export const login = (data) => {
    return API.post(URL.AUTH.POST_LOGIN, data)
};

export const resetPassword = (email) => {
    return API.post(URL.AUTH.RESET_PASSWORD, { email: email })
};

export const resetPasswordConfirm = (reset_password) => {
    return API.post(URL.AUTH.RESET_PASSWORD_CONFIRM, reset_password)
};